export default __webpack_public_path__ + "static/media/4.1e57b046.jpg";